var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { skipToken, useQuery } from '@tanstack/react-query';
import { useAuthProvider } from '#context';
import { usePlugFilespaceClient } from '../../../hooks';
import { FilespaceEntryPathKeyFactory } from '../../../query-key-factories';
export const useFsEntryGetPath = ({ filespaceId, key, workspaceId, }) => {
    _react_refresh_temp_1();
    const { currentUser } = useAuthProvider();
    const { plugFilespaceClient } = usePlugFilespaceClient();
    const query = useQuery({
        queryKey: FilespaceEntryPathKeyFactory.exact(filespaceId, key?.id || ''),
        queryFn: key && key.id.length
            ? async () => plugFilespaceClient({
                action: (fsClient) => fsClient.fileSystem().getPath(key),
                filespaceId,
                workspaceId,
            })
            : skipToken,
        enabled: Boolean(currentUser?.emailVerified),
        networkMode: 'always',
    });
    return { query };
};
_react_refresh_temp_1(useFsEntryGetPath, "jRMx3r7nIBDWbUBVlsDJFgWprew=", false, () => [useAuthProvider, usePlugFilespaceClient, useQuery]);
